import { render, staticRenderFns } from "./DetailProduct.vue?vue&type=template&id=3ea4648c&scoped=true"
import script from "./DetailProduct.vue?vue&type=script&lang=ts"
export * from "./DetailProduct.vue?vue&type=script&lang=ts"
import style0 from "./DetailProduct.vue?vue&type=style&index=0&id=3ea4648c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4648c",
  null
  
)

export default component.exports